import { render, staticRenderFns } from "./MobileSheetItem.vue?vue&type=template&id=3a75dd38&scoped=true"
import script from "./MobileSheetItem.vue?vue&type=script&lang=js"
export * from "./MobileSheetItem.vue?vue&type=script&lang=js"
import style0 from "./MobileSheetItem.vue?vue&type=style&index=0&id=3a75dd38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a75dd38",
  null
  
)

export default component.exports